import React from 'react';

const PlatformLayout = ({ 
  children, 
  className = '', 
  style = {},
  ...props 
}) => {
  // Build CSS class name for ALL platforms using token-based classes
  const getClassName = () => {
    const baseClass = 'layout-container';
    
    return [baseClass, className]
      .filter(Boolean)
      .join(' ');
  };

  // Minimal inline styles for ALL platforms
  const getInlineStyles = () => {
    const styles = {};
    
    // Only add styles that CANNOT be handled by CSS
    return { ...styles, ...style };
  };

  return (
    <div 
      className={getClassName()}
      style={getInlineStyles()}
      {...props}
    >
      {children}
    </div>
  );
};

export default PlatformLayout; 